import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './assets/case-create-screen.module.scss';
import RoleLayout from 'src/components/layout/RoleLayout';
import Loader from 'src/components/Loader';
import Form from '../../components/CaseForm';
import Breadcrumbs from 'src/components/Breadcrumbs';
import { routes } from 'src/navigation';
import OrderEnum from 'src/enumerables/order-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { Paginated } from 'src/services/api-handlers/pagination';
import { IOrder } from 'src/types/order';
import { IProvider } from 'src/types/provider';

import { QueryParams } from 'src/types/grid';

import { IServiceLocation } from 'src/types/service-locations';

import CaseEnum from 'src/enumerables/case-enum';
import { IServiceType } from 'src/types/service-types';
import { changeToZeroMoment, changeToZeroMomentDate } from '../../../../../../helpers/timeHelpers';
import { IServiceTypeProvider } from '../../../../../../types/service-types-providers';
import { getCheckCases, resetDouble } from '../../../../../../store/actions/case-actions';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { SubmissionError } from 'redux-form';
import { getCheckOrders } from '../../../../../../store/actions/order-actions';

export interface StateProps {
    inProgress: boolean;
    inProgressVendors: boolean;
    inProgressDistrict: boolean;
    inProgressStudent: boolean;
    inProgressProvider: boolean;

    orderTypes: any;
    caseTypes: SelectObject[];
    orders: Paginated<IOrder>;
    providers: Paginated<IProvider>;
    students: SelectObject[];
    vendors: SelectObject[];
    districts: SelectObject[];
    serviceTypes: Paginated<IServiceType>;
    serviceLocations: Paginated<IServiceLocation>;
    serviceTypeProviders: SelectObject[];

    valuesForm: { [key: string]: any };
    caseTypeValue: string | number;
    invoiceSignerValue: string | number;
    statusItemValue: string | number;
    orderValue: string | number;
    orderTypeValue: string | number;
    serviceTypeProviderValue: string | number;
    isDouble: any;
}

export interface DispatchProps {
    getOrders: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
    getServiceLocations: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getStudents: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
    changeValue: (field: string, value: string | null) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const CaseCreateScreen: React.FunctionComponent<Props> = (props) => {
    const [isOrdersFetch, setOrdersFethed] = useState(false);
    const [files, setFiles] = useState([]);
    const [dataSaveModal, setSaveModal] = useState(false);

    const AuthorizationSources = OrderEnum ? OrderEnum.getEnum('AuthorizationSource') : {};
    const valuesAuthorizationSources: SelectObject[] = getValFromEnum(AuthorizationSources);

    const AllocatedPeriod = OrderEnum ? OrderEnum.getEnum('AllocatedPeriod') : {};
    const valuesAllocatedPeriod: SelectObject[] = getValFromEnum(AllocatedPeriod);

    const MinPerUnit = CaseEnum ? CaseEnum.getEnum('MinPerUnit') : {};
    const minPerUnitValues: SelectObject[] = getValFromEnum(MinPerUnit);

    const InvoiceSigner = CaseEnum ? CaseEnum.getEnum('InvoiceSigner') : {};
    const invoiceSignerValues: SelectObject[] = getValFromEnum(InvoiceSigner);

    const CaseStatus = CaseEnum ? CaseEnum.getEnum('CaseStatus') : {};
    const statusValues: SelectObject[] = getValFromEnum(CaseStatus);

    const ServiceTypeProviders = OrderEnum ? OrderEnum.getEnum('ServiceTypeProvider') : {};
    const valuesServiceTypeProviders: SelectObject[] = getValFromEnum(ServiceTypeProviders);

    const ServiceTypeProvider = OrderEnum ? OrderEnum.getEnum('ServiceTypeProvider') : {};
    const serviceTypeProviderValues: SelectObject[] = getValFromEnum(ServiceTypeProvider);

    const dispatch = useDispatch();

    const handleCheck = (event: any) => {
        console.log('handleCheck', props);

        let filterByCaseType: any = {};
        if (props?.caseTypeValue == 1) {
            filterByCaseType = { 'student.id': props?.valuesForm?.student };
        } else if (props?.caseTypeValue == 2) {
            filterByCaseType = { 'student.id': props?.valuesForm?.studentDropDown?.value };
        } else if (props?.caseTypeValue == 4) {
            filterByCaseType = { 'vendor.id': props?.valuesForm?.vendorDropDown?.value };
        } else if (props?.caseTypeValue == 3) {
            filterByCaseType = { 'district.id': props?.valuesForm?.districtDropDown?.value };
        }
        let filterCaseNumber: any = {};
        if (props?.valuesForm?.caseNumberValue) {
            filterCaseNumber = { 'orderEntity.caseNumber': props?.valuesForm?.caseNumberValue };
        }
        let filterProvider: any = {};
        if (props?.valuesForm?.providerDropDown) {
            filterProvider = { 'occasionProviders.provider': props?.valuesForm?.providerDropDown?.value };
        }
        let filterServiceLocation: any = {};
        if (props?.valuesForm?.serviceLocationDropDown) {
            filterServiceLocation = {
                'occasionServiceLocations.serviceLocation': props?.valuesForm?.serviceLocationDropDown?.value,
            };
        }
        let filterServiceType: any = {};
        if (props?.valuesForm?.serviceType) {
            filterServiceType = { 'serviceType.id': props?.valuesForm?.serviceType };
        } else if (props?.valuesForm?.serviceTypeDropDown) {
            filterServiceType = {
                'serviceType.id': props?.valuesForm?.serviceTypeDropDown?.value,
            };
        }

        dispatch(
            getCheckCases({
                page: 1,
                filters: {
                    ...filterByCaseType,
                    ...filterCaseNumber,
                    ...filterProvider,
                    ...filterServiceLocation,
                    ...filterServiceType,
                    caseType: props?.caseTypeValue,
                    'orderEntity.orderType': props?.orderTypeValue,
                    //'occasionProviders.provider': 1,
                    //'occasionServiceLocations.serviceLocation':1,
                    //'serviceType.id': 1,
                },
                itemsPerPage: 80,
            }),
        );

        // console.log('counter ', counter);

        //  setIsAllNameChecked(counter);
    };

    useEffect(() => {
        setSaveModal(props.isDouble == 'no' ? false : props.isDouble);
    }, [props.isDouble]);

    const {
        getServiceLocations,
        getProviders,
        getStudents,
        inProgressProvider,
        getOrders,
        getServiceTypes,
        inProgressVendors,
        inProgressDistrict,
        inProgressStudent,
    } = props;
    useEffect(() => {
        getServiceLocations({
            page: 1,
            itemsPerPage: 1200,
        });
        getProviders({
            page: 1,
            itemsPerPage: 1200,
        });

        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        setOrdersFethed(false);
    }, [props.orderTypeValue, props.caseTypeValue]);
    useEffect(() => {
        //  props.getOrders(props.orderTypeValue);
        props.changeValue('ordersDropDown', null);
        if (props.orderTypeValue && !isOrdersFetch) {
            getOrders({
                page: 1,
                filters: {
                    orderType: props.orderTypeValue,
                    orderCaseType: props.caseTypeValue,
                },
                itemsPerPage: 80,
            });

            delete props.valuesForm.ordersDropDown;

            getServiceTypes({
                page: 1,
                filters: {
                    // orderType: props.orderTypeValue,
                },
                itemsPerPage: 9000,
            });
        }
        // eslint-disable-next-line
    }, [props.orderTypeValue, props.caseTypeValue]);
    useEffect(() => {
        props.changeValue('orderTypeDropDown', null);

        if (+props.caseTypeValue === 1 || +props.caseTypeValue === 5) {
            props.changeValue('caseNumberValidityFrom', null);
            props.changeValue('caseNumberValidityTo', null);
        }
        // eslint-disable-next-line
        if (+props.caseTypeValue === 2) {
            getStudents({
                page: 1,
                itemsPerPage: 9000,
            });
        } else if (+props.caseTypeValue === 3) {
            props.getDistricts({
                page: 1,
                itemsPerPage: 9000,
            });
            getStudents({
                page: 1,
                itemsPerPage: 9000,
            });
            const last: any = props.orderTypes.length - 1;
            props.changeValue('orderTypeDropDown', props.orderTypes[+last]);
        } else if (+props.caseTypeValue === 4) {
            props.getVendors({
                page: 1,
                itemsPerPage: 9000,
            });
            const last: any = props.orderTypes.length - 1;
            props.changeValue('orderTypeDropDown', props.orderTypes[+last]);
        }
        // eslint-disable-next-line
    }, [props.caseTypeValue]);
    const infoEntity = {
        caseAuthorizationValue: '',
        caseNumberValue: '',
        caseAuthorizationSourceValue: '',
        caseNumberValidityValue: '',
        AllocatedHoursPerValue: '',
        NumberHoursAllocatedValue: '',
        MoneyAllocatedValue: '',
        ServiceTypeValue: '',
        serviceTypeProviderValue: '',
        studentFullNameValue: '',
        studentId: '',
        ServiceTypeId: '',
        caseNumberValidityFrom: '',
        caseNumberValidityTo: '',
    };

    const OrderValues: SelectObject[] = [];
    props.orders.list.forEach((it: Partial<IOrder>) => {
        OrderValues.push({ value: it.id, label: `${it.name}` });
        if (props.orderValue === it.id) {
            infoEntity.caseAuthorizationValue = `${changeToZeroMoment(it.authorizationDate, 'MMM D, YYYY')}`;
            infoEntity.caseNumberValue = `${it?.caseNumber}`;
            const valueSource = valuesAuthorizationSources.find((itSourse) => {
                return itSourse.value === it.authorizationSource;
            });
            infoEntity.caseAuthorizationSourceValue = valueSource ? `${valueSource?.label}` : '';

            const valueServiceTypeProvider = valuesServiceTypeProviders.find((itSourse) => {
                return itSourse.value === it.serviceTypeProvider;
            });
            infoEntity.serviceTypeProviderValue = valueServiceTypeProvider ? `${valueServiceTypeProvider?.label}` : '';
            infoEntity.caseNumberValidityValue = `${changeToZeroMoment(
                it.caseNumberValidityFrom,
                'MMM D, YYYY',
            )} - ${changeToZeroMoment(it.caseNumberValidityTo, 'MMM D, YYYY')}`;
            infoEntity.caseNumberValidityFrom = `${it.caseNumberValidityFrom}`;
            infoEntity.caseNumberValidityTo = `${it.caseNumberValidityTo}`;
            const valuePeriod = valuesAllocatedPeriod.find((itPeriod) => {
                return itPeriod.value === it.allocatedPeriod;
            });

            infoEntity.AllocatedHoursPerValue = valuePeriod ? `${valuePeriod?.label}` : '';
            infoEntity.NumberHoursAllocatedValue = `${it?.allocatedHours}`;
            infoEntity.MoneyAllocatedValue = `${it?.allocatedMoney}`;

            const labelArr = [];
            if (it?.serviceType?.title) {
                labelArr.push(it?.serviceType?.title);
            }
            if (it?.serviceType?.cpt) {
                labelArr.push(`CPT: [${it?.serviceType?.cpt}]`);
            }
            const label = labelArr.join(', ');

            infoEntity.ServiceTypeValue = label;
            // ServiceTypeValue = `${it?.serviceType ? serviceTypes[${it.serviceType] : ''}`;

            infoEntity.studentFullNameValue = it?.student ? `${it?.student?.firstName} ${it?.student?.lastName}` : '';

            infoEntity.studentId = it?.student?.id ? `${it?.student?.id}` : '';

            infoEntity.ServiceTypeId = it?.serviceType?.id ? it?.serviceType?.id : '';
        }
    });

    let numberOfHoursBilled = '';
    let changesData = {};
    if (props.valuesForm) {
        const externalRatePerHour = props.valuesForm.externalRatePerHour;
        const externalEvalHourlyRate = props.valuesForm.externalEvalHourlyRate;
        numberOfHoursBilled = `${(+externalRatePerHour / +externalEvalHourlyRate).toFixed(1)}`;

        if (props.caseTypeValue === 1 || +props.caseTypeValue === 5) {
            changesData = {
                caseNumberValidityFrom: infoEntity.caseNumberValidityFrom,
                caseNumberValidityTo: infoEntity.caseNumberValidityTo,
                caseNumberValue: infoEntity.caseNumberValue,
            };
        }
    }

    const valueLocations: { [key: string]: SelectObject } = {};
    props.serviceLocations.list.forEach((itLoc: IServiceLocation) => {
        if (itLoc.title === 'Home - In person') {
            valueLocations.serviceLocationDropDown = { value: itLoc.id, label: `${itLoc.title}` };
        }
    });
    return (
        <RoleLayout>
            <Breadcrumbs
                items={[
                    { name: 'CASES', path: routes.CASES_LIST },
                    { name: `ADD NEW`, path: '' },
                ]}
            />
            <div className={classNames(styles.wrapForm)}>
                <div className="d-flex justify-content-center mb-4 flex-row">
                    <h3 className={classNames(`${styles.activeTab} mr-5 pb-1`)}>Step 1</h3>
                    <h3>Step 2</h3>
                </div>
                {props.inProgress ||
                inProgressProvider ||
                inProgressVendors ||
                inProgressDistrict ||
                inProgressStudent ? (
                    <Loader />
                ) : null}
                <Form
                    files={files}
                    setFiles={setFiles}
                    orderTypes={props.orderTypes}
                    infoEntity={infoEntity}
                    OrderValues={OrderValues}
                    caseTypes={props.caseTypes}
                    orderTypeValue={props.orderTypeValue}
                    caseTypeValue={props.caseTypeValue}
                    serviceTypeProviderValue={props.serviceTypeProviderValue}
                    invoiceSignerValue={props.invoiceSignerValue}
                    statusItemValue={props.statusItemValue}
                    removeFile={(id) => {
                        files.splice(id, 1);
                        setFiles([...files]);
                    }}
                    minPerUnitValues={minPerUnitValues}
                    statusValues={statusValues}
                    invoiceSignerValues={invoiceSignerValues}
                    serviceTypeProviderValues={serviceTypeProviderValues}
                    providers={props.providers.list}
                    students={props.students}
                    districts={props.districts}
                    vendors={props.vendors}
                    serviceTypes={props.serviceTypes.list}
                    serviceTypeProviders={props.serviceTypeProviders}
                    serviceLocations={props.serviceLocations.list}
                    numberOfHoursBilled={!!+numberOfHoursBilled ? numberOfHoursBilled : '0'}
                    initialValues={{
                        ...valueLocations,
                        minPerUnitDropdown: { label: '60', value: 60 },
                        ...props.valuesForm,
                        serviceType: infoEntity.ServiceTypeId,
                        student: infoEntity.studentId,
                        ...changesData,
                    }}
                    valuesForm={props.valuesForm}
                    dataSaveModal={dataSaveModal}
                    setSaveModal={setSaveModal}
                    handleCheck={handleCheck}
                    isDouble={props.isDouble}
                    resetDouble={() => dispatch(resetDouble())}
                />
            </div>
        </RoleLayout>
    );
};

export default CaseCreateScreen;
